import { Box, Typography } from "@mui/material";

export const DetailSection = ({ heading, content, index }) => {
  return (
    <Box sx={{ mt: 1, mb: 3, px: 3 }} key={heading + index}>
      <Typography
        component={"div"}
        variant="body1"
        fontSize={13}
        key={heading + index + 1}
      >
        {heading}
      </Typography>
      <Typography
        component={"div"}
        variant="body2"
        style={{ whiteSpace: "pre-line", color: "#9e9e9e" }}
        key={content + index}
      >
        {typeof content === "string" ? content : "-"}
      </Typography>
    </Box>
  );
};
